import { createFileRoute } from '@tanstack/react-router';

import { ClientSessionsScreen } from '@/features/sessions/components/client/ClientSessionsScreen';

export const Route = createFileRoute('/client/sessions/')({
  component: ClientSessionsRoute,
});

function ClientSessionsRoute() {
  return <ClientSessionsScreen />;
}
